<template>
    <el-card>
        <el-row class="banFunction__title">功能封禁记录</el-row>
        <!-- 搜索 -->
        <el-row class="banFunction__search">
            <div class="item">
                <span>用户RID：</span>
                <el-input v-model="search.rid" style="width: 150px" placeholder="请输入用户RID"></el-input>
                <el-button style="margin-left: 10px;" type="primary" @click="getList(1)">搜索</el-button>
            </div>
        </el-row>
        <!-- 表格 -->
        <el-table :data="tableList" border>
            <el-table-column prop="rid" align="center" label="用户RID"></el-table-column>
            <el-table-column prop="name" align="center" label="用户昵称"></el-table-column>
            <el-table-column prop="banDesc" align="center" label="封禁原因"></el-table-column>
            <el-table-column prop="banTypeStr" align="center" label="封禁类型"></el-table-column>
            <el-table-column prop="optUid" align="center" label="操作人"></el-table-column>
            <el-table-column prop="createDate" align="center" label="封禁时间"></el-table-column>
            <el-table-column prop="fixDate" align="center" label="修改时间"></el-table-column>
            <el-table-column prop="banTimeStr" align="center" label="封禁截止时间"></el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button type="info" v-if="scope.row.banOpt == 1" @click="handleUnban(scope.row)">解封</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                :current-page.sync="currentPage" @current-change="guaranteedHandleCurrentChange">
            </el-pagination>
        </el-row>
    </el-card>
</template>

<script>
export default {
    data() {
        return {
            search: {
                rid: null
            },
            tableList: [],
            total: 0,
            currentPage: 1,
            pageSize: 30,
        }
    },
    created() {
        this.getList()
    },
    methods: {
        handleUnban(row) {
            this.$confirm('确定解封该用户吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.unban(row.id)
            })
        },
        async unban(id) {
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.ban_function_update,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    id,
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.getList()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        guaranteedHandleCurrentChange(page) {
            this.getList(page)
        },
        // 格式化时间
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property] * 1000
            if (data == null) {
                return null
            }
            let dt = new Date(data)
            return (
                dt.getFullYear() +
                '-' +
                (dt.getMonth() + 1) +
                '-' +
                dt.getDate() +
                ' ' +
                dt.getHours() +
                ':' +
                dt.getMinutes() +
                ':' +
                dt.getSeconds()
            )
        },
        // 获取数据列表
        async getList(page) {
            if (page) {
                this.currentPage = page
            }
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.ban_function_query,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    ...this.search,
                    page: this.currentPage,
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.tableList = res.data.data
                this.total = res.data.total
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
    }
}
</script>
<style scoped lang="scss">
.banFunction {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }

        .searchBtn {
            margin-left: 10px;
        }
    }
}
</style>
